export const complianceChecksOfferingType = {
   VERIFY_ITR_COMPLIANCE: { key: "verifyITR206Compliance", label: "Verify ITR 206 Compliance" },
};

export const complianceChecksSteps = {
   INITIAL_STEP: 0,
   USER_DETAILS: 1,
   RESULT: 2,
};
